/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseErrorNotFoundAllOfError } from './ResponseErrorNotFoundAllOfError';
import {
    ResponseErrorNotFoundAllOfErrorFromJSON,
    ResponseErrorNotFoundAllOfErrorFromJSONTyped,
    ResponseErrorNotFoundAllOfErrorToJSON,
} from './ResponseErrorNotFoundAllOfError';

/**
 * 
 * @export
 * @interface ResponseErrorNotFound
 */
export interface ResponseErrorNotFound {
    /**
     * 
     * @type {ResponseErrorNotFoundAllOfError}
     * @memberof ResponseErrorNotFound
     */
    error: ResponseErrorNotFoundAllOfError;
}

/**
 * Check if a given object implements the ResponseErrorNotFound interface.
 */
export function instanceOfResponseErrorNotFound(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function ResponseErrorNotFoundFromJSON(json: any): ResponseErrorNotFound {
    return ResponseErrorNotFoundFromJSONTyped(json, false);
}

export function ResponseErrorNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorNotFound {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': ResponseErrorNotFoundAllOfErrorFromJSON(json['error']),
    };
}

export function ResponseErrorNotFoundToJSON(value?: ResponseErrorNotFound | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ResponseErrorNotFoundAllOfErrorToJSON(value.error),
    };
}

